/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseClient } from '../base-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteBlob } from '../fn/storage/delete-blob';
import { DeleteBlob$Params } from '../fn/storage/delete-blob';
import { getBlobContent } from '../fn/storage/get-blob-content';
import { GetBlobContent$Params } from '../fn/storage/get-blob-content';
import { listBlobs } from '../fn/storage/list-blobs';
import { ListBlobs$Params } from '../fn/storage/list-blobs';
import { OrchestrateBlobMetadata as StorageOrchestrateBlobMetadata } from '../models/storage/orchestrate-blob-metadata';
import { updateAccessData } from '../fn/storage/update-access-data';
import { UpdateAccessData$Params } from '../fn/storage/update-access-data';
import { uploadBlob } from '../fn/storage/upload-blob';
import { UploadBlob$Params } from '../fn/storage/upload-blob';

@Injectable({ providedIn: 'root' })
export class StorageClient extends BaseClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `storageListBlobs()` */
  static readonly StorageListBlobsPath = '/blob';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listBlobs()` instead.
   *
   * This method doesn't expect any request body.
   */
  listBlobs$Response(params: ListBlobs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<StorageOrchestrateBlobMetadata>>> {
    const obs = listBlobs(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listBlobs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listBlobs(params: ListBlobs$Params, context?: HttpContext): Observable<Array<StorageOrchestrateBlobMetadata>> {
    const resp = this.listBlobs$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<StorageOrchestrateBlobMetadata>>): Array<StorageOrchestrateBlobMetadata> => r.body)
    );
  }

  /** Path part for operation `storageUploadBlob()` */
  static readonly StorageUploadBlobPath = '/blob';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadBlob()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadBlob$Response(body: UploadBlob$Params['body'], context?: HttpContext): Observable<StrictHttpResponse<StorageOrchestrateBlobMetadata>> {
    const obs = uploadBlob(this.http, this.rootUrl, { body } satisfies UploadBlob$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadBlob$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadBlob(body: UploadBlob$Params['body'], context?: HttpContext): Observable<StorageOrchestrateBlobMetadata> {
    const resp = this.uploadBlob$Response(body, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StorageOrchestrateBlobMetadata>): StorageOrchestrateBlobMetadata => r.body)
    );
  }

  /** Path part for operation `storageGetBlobContent()` */
  static readonly StorageGetBlobContentPath = '/blob/{blobId}/file';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBlobContent()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBlobContent$Response(blobId: string, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = getBlobContent(this.http, this.rootUrl, { blobId } satisfies GetBlobContent$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBlobContent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBlobContent(blobId: string, context?: HttpContext): Observable<Blob> {
    const resp = this.getBlobContent$Response(blobId, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `storageUpdateAccessData()` */
  static readonly StorageUpdateAccessDataPath = '/blob/{blobId}/access-data';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAccessData()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAccessData$Response(blobId: string, body: UpdateAccessData$Params['body'], context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateAccessData(this.http, this.rootUrl, { blobId, body } satisfies UpdateAccessData$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAccessData$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAccessData(blobId: string, body: UpdateAccessData$Params['body'], context?: HttpContext): Observable<void> {
    const resp = this.updateAccessData$Response(blobId, body, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `storageDeleteBlob()` */
  static readonly StorageDeleteBlobPath = '/blob/{blobId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteBlob()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteBlob$Response(blobId: string, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteBlob(this.http, this.rootUrl, { blobId } satisfies DeleteBlob$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteBlob$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteBlob(blobId: string, context?: HttpContext): Observable<void> {
    const resp = this.deleteBlob$Response(blobId, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
